import update from 'immutability-helper';
import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function licenceReducer(state = initialState.licences, action) {
  const content = { ...state };

  switch (action.type) {
    case types.GET_LICENCE_INFO_SUCCESS:
      content.information = action.data;
      return content;

    case types.GET_ALLOCATED_LICENCES_SUCCESS: {
      const { data, links } = action.res;
      content.allocated = data;
      content.links = links;
      return content;
    }

    case types.ALLOCATE_LICENCE_SUCCESS: {
      const newLicencee = action.data;
      newLicencee.attributes.isNew = true;
      content.allocated = [action.data, ...state.allocated];
      return content;
    }

    case types.REMOVE_LICENCE_SUCCESS:
      content.allocated = content.allocated.filter(licence => licence.id !== action.licenceId);
      return content;

    case types.EDIT_LICENCE_SUCCESS: {
      content.allocated = content.allocated.map((licence) => {
        if (licence.id === action.licenceId) {
          return update(licence, {
            attributes: { 'licence-type': { $set: action.newLicenceType } },
          });
        }
        return licence;
      });
      return content;
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./library/app/reducers/licenceReducer.js